import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';
import '../styles/Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Login attempt with username:', formData.username);
      const result = await login(formData.username, formData.password);
      console.log('Login result:', result);
      
      if (result.success) {
        toast.success('Erfolgreich angemeldet!');
        setTimeout(() => {
          navigate('/admin');
        }, 500);
      } else {
        toast.error(result.error || 'Benutzername oder Passwort falsch');
        setLoading(false);
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Ein Fehler ist aufgetreten: ' + (error.message || 'Netzwerkfehler'));
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <Card className="login-card">
          <div className="login-header">
            <div className="login-icon">
              <Lock size={40} />
            </div>
            <h1 className="login-title">Admin Login</h1>
            <p className="login-subtitle">Gratl-Montage</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                <User size={16} /> Benutzername
              </label>
              <Input
                id="username"
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
                placeholder="admin"
                required
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <Lock size={16} /> Passwort
              </label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>

            <Button
              type="submit"
              className="btn-primary btn-full-width"
              disabled={loading}
            >
              {loading ? 'Anmeldung läuft...' : 'Anmelden'}
            </Button>
          </form>

          <div className="login-footer">
            <a href="/" className="back-link">← Zurück zur Homepage</a>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;
